module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/clear.676018ec.svg";